export const resizeImage = async (fileType: string, image: HTMLImageElement) => {
    const maxSize = 1568;
    const maxMegapixels = 1.15;

    let {width, height} = image;

    if (width > maxSize || height > maxSize || (width * height) > (maxMegapixels * 1e6)) {
        const aspectRatio = width / height;
        if (width > height) {
            width = maxSize;
            height = Math.round(width / aspectRatio);
        } else {
            height = maxSize;
            width = Math.round(height * aspectRatio);
        }
    }

    if (fileType === "image/gif") {
        return image.src;
    } else {
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx!.drawImage(image, 0, 0, width, height);
        return canvas.toDataURL(fileType);
    }
}